















import Component from "vue-class-component";
import { Prop, Provide, Vue } from "vue-property-decorator";
import ProjectListPage from "@/custom/page/filemanager/project/ProjectListPage.vue";
import ImportFilePage from "@/custom/page/filemanager/file/ImportFilePage.vue";
import FileListPage from "@/custom/page/filemanager/file/FileListPage.vue";
import MenuLayoutPage from "@/custom/page/common/MenuLayoutPage.vue";
import ProjectService from "@/entities/project/project.service";
import FileGeodeticService from "@/entities/file-geodetic/file-geodetic.service";
import UploadProgressSheet from "@/custom/page/common/UploadProgressSheet.vue";

export const selectMenuKey = 'FileManagerPage_selectMenu';
const currentPath = '/file-manager-page';
@Component({ components: { UploadProgressSheet, ProjectListPage, ImportFilePage, FileListPage, MenuLayoutPage } })
export default class FileManagerPage extends Vue {
  projectObj = {
    projects: [],
    loading: false,
    reload: page => this.fetchProjects(page),
    onLoadDone: () => undefined,
    loadDone: false,
  };
  @Provide() projectsFn = () => this.projectObj;

  fileObj = {
    files: [],
    loading: false,
    reload: page => this.fetchFiles(page),
    onLoadDone: () => undefined,
    loadDone: false,
  };
  @Provide() filesFn = () => this.fileObj;

  uploadProgress = {
    open: false,
    listComposeObject: {},
  };
  @Provide() uploadProgressFn = () => this.uploadProgress;
  @Provide() aggregateUploadProgressFn = () => this.$refs.uploadProgressSheet.aggregate();

  mounted() {
    this.fetchProjects();
    this.fetchFiles();
  }

  async fetchProjects(page = { page: 0, size: 5 }) {
    this.projectObj.loading = true;
    let projectService = new ProjectService();
    this.projectObj.projects = (await projectService.retrieve(page)).data;
    this.projectObj.loading = false;
    this.projectObj.loadDone = true;
    this.projectObj.onLoadDone();
  }

  async fetchFiles(page = { page: 0, size: 200 }) {
    this.fileObj.loading = true;
    let fileService = new FileGeodeticService();
    this.fileObj.files = (await fileService.retrieve(page)).data;
    this.fileObj.loading = false;
    this.fileObj.loadDone = true;
    this.fileObj.onLoadDone();
  }

  menus = [
    { title: 'Danh mục dự án', icon: 'mdi-calendar-check-outline', routeName: 'ProjectListPage' },
    { title: 'Thêm File', icon: 'mdi-import', routeName: 'ImportFilePage' },
    { title: 'Danh sách File', icon: 'mdi-format-list-bulleted', routeName: 'FileListPage' },
    { title: 'Tải xuống', icon: 'mdi-download', routeName: 'FileListPageDownload' },
  ];
  @Prop() selectMenuProp;

  menuMini = false;

  get contentWidth() {
    return this.menuMini ? 90 + 45 : 266 + 45;
  }

  get contentLeftPosition() {
    return this.menuMini ? 90 : 266;
  }

  onMenuMiniChange(menuMini) {
    this.menuMini = menuMini;
  }
}
